import PropTypes from 'prop-types';
import { prop, propOr } from 'ramda';
import { Icon, PageTitle, ProductCard } from '@fasstech/middle-design-system';
import { mapIndexed } from '@@serverHelpers/index.mjs';
import { PageLayout } from '@@viewCommonComponents/forms/Layouts.jsx';
import ButtonContainer from '@@viewCommonComponents/forms/ButtonContainer.jsx';
import useSimulationOfferGroupProtectionForm from './hooks/useSimulationOfferGroupProtectionForm.js';

// Vue « Offre » de la prévoyance collective : liste des offres éligibles, un clic sélectionne et poursuit
const SimulationOfferGroupProtectionForm = ({ getSimulationOfferGroupProtection, getMiddleText }) => {
  const { products, loadingOfferIndex, updateSelectedOffer, $onPrevClick } =
    useSimulationOfferGroupProtectionForm({ getSimulationOfferGroupProtection });

  return (
    <>
      <PageLayout withFormLayout={false} className=" flex-col items-center gap-y-6 ">
        <Icon name={'product'} size={70} />
        <PageTitle>{getMiddleText('PRODUCTS_VIEW_TITLE')}</PageTitle>
        <div className="flex flex-wrap gap-x-3 gap-y-4 mb-8 justify-center">
          {mapIndexed(
            (product, index) => (
              <ProductCard
                key={propOr(`offer-${index}`, 'code', product)}
                title={prop('name', product)}
                onArrowClick={() => updateSelectedOffer(index)}
                isActive={prop('isSelected', product)}
                loading={loadingOfferIndex === index}
              />
            ),
            products
          )}
        </div>
      </PageLayout>
      <ButtonContainer
        $onPreviousButtonClick={$onPrevClick}
        nextButtonIsHidden={true}
        displayPreviousButton
        getMiddleText={getMiddleText}
      />
    </>
  );
};

SimulationOfferGroupProtectionForm.propTypes = {
  getSimulationOfferGroupProtection: PropTypes.object,
  getMiddleText: PropTypes.func
};

export default SimulationOfferGroupProtectionForm;
